import {
	Component,
	OnInit,
	AfterViewInit,
	OnDestroy,
	ViewChildren,
	ElementRef
} from "@angular/core";
import { Subscription, Observable, fromEvent } from "rxjs";
import { FormBuilder, FormControlName, FormGroup } from "@angular/forms";

import {
	GlobalDataOpsService,
	GlobalDomOpsService,
	AcepSSOService,
	CommonOperationsService
} from "@acepteam/globalspack";
import {
	DomService,
	DataService,
	LoggerService,
	HelperService
} from "../../../core/services";
import { GroupPortalDataService, GroupPortalDomService } from "../../services";
import { Component2Service } from "../component2/component2.service";
import { Component1Service } from "../component1/component1.service";
import { DashboardService } from "../dashboard/dashboard.service";
import { MembersService } from "../members/members.service";
import { MyGroupService } from "../myGroup/myGroup.service";
import { HistoryService } from "../history/history.service";
import { Location } from "@angular/common";
import { environment } from "../../../../environments/environment";
import { DEFAULT_RESIZE_TIME } from "@angular/cdk/scrolling";
import { SideNavService } from "../side-nav/side-nav.service";
import { ActivatedRoute, Params } from "@angular/router";
import { first } from 'rxjs/operators';


declare var $: any;
@Component({
	selector: "app-groupportal-base",
	template: ""
})
export class MemberappBaseComponent
	implements OnInit, AfterViewInit, OnDestroy {
	@ViewChildren(FormControlName, { read: ElementRef })
	formInputElements: ElementRef[];

	public subscriptions: Array<Subscription> = [];
	public formSubmitted: boolean = false;
	public errorMessage: string = "";
	public isDevEnv: boolean = !environment.production;

	constructor(
		public globalDataOpsService: GlobalDataOpsService,
		public globalDomOpsService: GlobalDomOpsService,
		public commonOpsService: CommonOperationsService,
		public ssoService: AcepSSOService,
		public dataService: DataService,
		public domService: DomService,
		public helperService: HelperService,
		public groupPortalDataService: GroupPortalDataService,
		public memberAppDomService: GroupPortalDomService,
		public component2Service: Component2Service,
		public component1Service: Component1Service,
		public sideNavService: SideNavService,
		public dashboardService: DashboardService,
		public membersService: MembersService,
		public myGroupService: MyGroupService,
		public historyService: HistoryService,
		public loggerService: LoggerService,
		public location: Location,
		public fb: FormBuilder,
		public route: ActivatedRoute

	) {
		this.route.params.subscribe((params: Params) => {
			let id = params['groupId'];
			if (!!id) {
				this.groupPortalDataService.SetSelectedGroup(id);
			}
			if (!this.groupPortalDataService.groupList) {
				this.groupPortalDataService.initializeGroupList();
			}
			let activeGroup = (this.groupPortalDataService.groupList ? this.groupPortalDataService.groupList.groupNumber : '');
			if (id && (id !== activeGroup)) {
				this.groupPortalDataService.GetGroupPortalData().pipe(first());
				this.groupPortalDataService.SetGroupNumber(id);
				const newAccount = (activeGroup !== this.groupPortalDataService.groupList.groupNumber);
				this.groupPortalDataService.SetSelectedGroup(id);
				this.groupPortalDataService.callGroupAPIs(newAccount);

				this.groupPortalDataService.slideOutShown = false;
				this.groupPortalDataService.slideOutBlur();
				$('ul li.active.route').removeClass('active route');
				$('ul li button#members').parent().addClass('active route');
				console.log(this.route);
			}
		});
		this.initSubscriptions();

	}

	initSubscriptions() {

	}
	ngOnInit() { }

	//AkshayG: Se the heght of side nav based on the dashboard height
	//It will be decide based on the height of the router component
	//adjustModalHeight is the flag to decide if the height of the side nav should be equal to the height of the router component
	SideNavDisplay(openorclose: string) {
		const routerCompDiv = document.getElementById('routerComp');		
		if (openorclose == 'open') {
			//If side bar opens, disable the router component events
			if(routerCompDiv)					 
				routerCompDiv.style.pointerEvents = 'none';				 
				
			//AkshayG: Get the height of the router component
			var sideNavHeight =  document.getElementsByClassName("side-nav")[0].clientHeight;
              
			document.getElementById("mySidepanel").style.visibility = "visible";
			document.getElementById("mySidepanel").style.width = "40vw";
			//AkshayG: Set the height of the side nav based on the height of the router component
			document.getElementById("mySidepanel").style.height = (sideNavHeight <= 0 ? '700' :sideNavHeight)+"px";
		} else {
			//AkshayG: If side bar closes, enable the router component events
			if(routerCompDiv)
				routerCompDiv.style.pointerEvents = 'auto';

			//AkshayG: Set the default height
			document.getElementById("mySidepanel").style.height = "700px"
			document.getElementById("mySidepanel").style.width = "0";
			document.getElementById("mySidepanel").style.visibility = "hidden";
		}
	}

	ngAfterViewInit() {
		this.globalDomOpsService.hidewait();

		// let currentPage = this.location.path().substr(1);
		// console.log('gpbase this:' + currentPage);
		// switch (currentPage) {
		// 	case "dashboard":
		// 		console.log('we are on the ' + currentPage);
		// 		$('#GPsidenav ul li.leftnav-' + currentPage).addClass('active');
		// 		break;

		// 	default:
		// 		break;
		// }
		// Watch for the blur event from any input element on the form.
		// let controlBlurs: Observable<any>[] = this.formInputElements
		// .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscriptions.forEach((subscription: Subscription) => {
			subscription.unsubscribe();
		});
	}

	onError() {
		this.globalDomOpsService.notify("Internal Server Error", "", "error");
		this.loggerService.logError(this.errorMessage);
	}

	onSave(formGroup: FormGroup) {
		this.formSubmitted = true;
		this.helperService.markFormGroupTouched(formGroup);

		this.loggerService.logInfo(formGroup.value);
		this.loggerService.logInfo(`page is ${formGroup.status}`);

		if (formGroup.invalid) {
			let allErrors = this.helperService.getAllErrors(formGroup);
			this.loggerService.logError(JSON.stringify(allErrors));
			this.domService.scrollToFirstError();
		}
	}

	  //AkshayG: Open/Hide modal pop up based on user action
	  setModalVisibility(selector: string, displayValue: string, visibilityValue: string): void {
		const modalElement = $(selector);
	
		if (modalElement) {
			modalElement.css({
				display:displayValue,
				visibilty: visibilityValue
			})
		   
		}
	  }
}
